import { render, staticRenderFns } from "./RegisterPassword.vue?vue&type=template&id=3b9e5ed7&scoped=true&"
import script from "./RegisterPassword.vue?vue&type=script&lang=js&"
export * from "./RegisterPassword.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPassword.vue?vue&type=style&index=0&id=3b9e5ed7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9e5ed7",
  null
  
)

export default component.exports